// Auth Routes (Login required)
// import CreditcardRedirect from "../containers/state-page/redirect-cc";
import React from "react";

// Public Routes
// const Login = React.lazy(() => import("../containers/user/login"));
// const Register = React.lazy(() => import("../containers/user/register"));
// const Forgot = React.lazy(() => import("../containers/user/forgot"));
// const Recovery = React.lazy(() => import("../containers/user/recovery"));
const Home = React.lazy(() => import("../containers/home"));
const DashBoard = React.lazy(() => import("../containers/Dashboard"));
const LifeQuestionnaire = React.lazy(() =>
  import("../containers/journeys/Life/index.jsx")
);
const PetQuestionnaire = React.lazy(() =>
  import("../containers/journeys/Pet/index.js")
);
const CriticalIllnessQuestionnaire = React.lazy(() =>
  import("../containers/journeys/Critical/index.jsx")
);
const TravelQuestionnaire = React.lazy(() =>
  import("../containers/journeys/Travel/index.js")
);

const PetResult = React.lazy(() =>
  import("../containers/results/Pet/index.js")
);
const PetDetails = React.lazy(() =>
  import("../containers/results/Pet/PetDetails/index.js")
);
const CriticalResults = React.lazy(() =>
  import("../containers/results/Critical")
);
const Travelresults = React.lazy(() =>
  import("../containers/results/travel/results")
);
const LifeResults = React.lazy(() => import('../containers/results/Life'));

const TravelSummary = React.lazy(() =>
  import("../containers/summary/travel-new/index")
);
const PetSummary = React.lazy(() => import("../containers/summary/Pet/index"));
const CriticalSummary = React.lazy(() => import('../containers/summary/critical'))
const LifeSummary= React.lazy(() => import('../containers/summary/Life'))
const ThankYouPet = React.lazy(() => import('../containers/thank-you/Pet/index'))
const ThankYouTravel = React.lazy(() => import('../containers/thank-you/Travel'))
const ThankYouCritical = React.lazy(() => import('../containers/thank-you/critical/index'))
const ThankYouLife = React.lazy(() => import('../containers/thank-you/life'))

const TravelCompare = React.lazy(() => import('../containers/compare/compare-travel'))
const CompareLIFE=React.lazy(() => import('../containers/compare/compare-life-new'))
const NotFoundPage = React.lazy(() =>
  import("../containers/state-page/not-found")
);

const routes = [
  {
    path: "/",
    exact: true,
    name: "Home",
    component: Home,
    authRequired: false,
  },
  {
    path: "/not-found",
    exact: true,
    name: "NotFoundPage",
    component: NotFoundPage,
    authRequired: false,
  },
  // {
  //   path: "/login",
  //   exact: true,
  //   name: "Login",
  //   component: Login,
  //   authRequired: false,
  // },
  // {
  //   path: "/register",
  //   exact: true,
  //   name: "Register",
  //   component: Register,
  //   authRequired: false,
  // },
  // {
  //   path: "/forgot",
  //   exact: true,
  //   name: "Forgot",
  //   component: Forgot,
  //   authRequired: false,
  // },
  // {
  //   path: "/restore",
  //   exact: true,
  //   name: "Recovery",
  //   component: Recovery,
  //   authRequired: false,
  // },

  // {
  //   path: "/seguro-myworld/resultados/pacotes",
  //   exact: true,
  //   name: "MyWorldResults",
  //   component: MyWorldResults,
  //   authRequired: false,
  // },

  // {
  //   path: "/seguro-myworld/simulacao/",
  //   exact: true,
  //   name: "MyWorldJourney",
  //   component: MyWorldJourney,
  //   authRequired: false,
  // },

  {
    path: "/dashboard",
    exact: true,
    name: "Dashboard",
    component: DashBoard,
    authRequired: false,
  },

  {
    path: "/seguro-viagem/simulacao/:journeyId?",
    exact: true,
    name: "TravelJourney",
    component: TravelQuestionnaire,
    authRequired: false,
  },
  {
    path: "/seguro-animais-domesticos/simulacao/:journeyId?",
    exact: true,
    name: "PetInsuranceJourney",
    component: PetQuestionnaire,
    authRequired: false,
  },
  {
    path: "/seguro-animais-domesticos/resultados/pacotes/:journeyId?",
    exact: true,
    name: "PetResult",
    component: PetResult,
    authRequired: false,
  },
  {
    path: '/seguro-viagem/resultados/comparar/:journeyId?',
    exact: true,
    name: 'TravelCompare',
    component: TravelCompare,
    authRequired: false
  },
  {
    path: "/seguro-animais-domesticos/resultados/comparar/:journeyId?",
    exact: true,
    name: "PetDetails",
    component: PetDetails,
    authRequired: false,
  },
  {
    path: "/seguro-animais-domesticos/resultados/summary/:orderId?",
    exact: true,
    name: "PetSummary",
    component: PetSummary,
    authRequired: false,
  },
  {
    path: '/seguro-animais-domesticos/compra/obrigado/:orderId?',
    exact: true,
    name: 'ThankYouPet',
    component: ThankYouPet,
    authRequired: false
  },
  {
    path: "/seguro-vida/simulacao/:journeyId?",
    exact: true,
    name: "LifeJourney",
    component: LifeQuestionnaire,
    authRequired: false,
  },
  {
    path: "/doencas-graves/simulacao/:journeyId?",
    exact: true,
    name: "Critical",
    component: CriticalIllnessQuestionnaire,
    authRequired: false,
  },
  {
    path: "/doencas-graves/resultados/pacotes/:journeyId?",
    exact: true,
    name: "CriticalResults",
    component: CriticalResults,
    authRequired: false,
  },
  {
    path: '/doencas-graves/resultados/summary/:orderId?',
    exact: true,
    name: 'CriticalSummary',
    component: CriticalSummary,
    authRequired: false
  },
  {
    path: '/doencas-graves/compra/obrigado/:orderId?',
    exact: true,
    name: 'ThankYouCritical',
    component: ThankYouCritical,
    authRequired: false
  },
  {
    path: "/seguro-viagem/resultados/pacotes/:journeyId?",
    exact: true,
    name: "Travelresults",
    component: Travelresults,
    authRequired: false,
  },
  {
    path: "/seguro-viagem/resultados/summary/:orderId?",
    exact: true,
    name: "TravelSummary",
    component: TravelSummary,
    authRequired: false,
  },
  {
    path: '/seguro-viagem/compra/obrigado/:orderId',
    exact: true,
    name: 'ThankYou',
    component: ThankYouTravel,
    authRequired: false
  },
  {
    path: '/seguro-vida/resultados/pacotes/:journeyId?',
    exact: true,
    name: 'LIFEPackage',
    component: LifeResults,
    authRequired: false
  },
  {
    path: '/seguro-vida/resultados/comparar/:journeyId?',
    exact: true,
    name: 'CompareLIFE',
    component: CompareLIFE,
    authRequired: false
  },
  {
    path: '/seguro-vida/resultados/summary/:orderId?',
    exact: true,
    name: 'LifeSummary',
    component: LifeSummary,
    authRequired: false
  },
  {
    path: '/seguro-vida/compra/obrigado/:orderId',
    exact: true,
    name: 'ThankYouLife',
    component: ThankYouLife,
    authRequired: false
  },
  // {
  //   path: "/seguro-myworld/resultados/summary",
  //   exact: true,
  //   name: "MyWorldSummary",
  //   component: MyWorldSummary,
  //   authRequired: false,
  // },
  // {
  //   path: "/seguro-myworld/compra/obrigado",
  //   exact: true,
  //   name: "ThankYouMyWorld",
  //   component: ThankYouMyWorld,
  //   authRequired: false,
  // },
];

export default routes;
